import { StoreEnhancer, applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import reducer from 'states/dux'

const configureStore = (): any => {
  const middleware: StoreEnhancer = applyMiddleware(thunk)
  return createStore(reducer(), middleware)
}

export { configureStore }
